import { useMemo } from 'react';
import {
  createAdriverCustom,
  CreateAdriverCustomParams
} from '../../utils/helpers/createAdriverCustom';
import { useTargetedBanner } from '.';
import { TargetedBannerIds } from '../../types';

interface AdriverTargetingProps extends CreateAdriverCustomParams {
  shouldNotRunOnRouter?: boolean;
}

export const useAdriverTargeting = ({
  leased,
  rooms,
  categoryId,
  hasRepair,
  cityName,
  price,
  hasBillOfSale,
  hasMortgage,
  shouldNotRunOnRouter = false
}: AdriverTargetingProps) => {
  const adriverCustom = useMemo(() => {
    return createAdriverCustom({
      leased: typeof leased === 'boolean' ? leased.toString() : leased,
      rooms,
      categoryId,
      hasRepair:
        typeof hasRepair === 'boolean' ? hasRepair.toString() : hasRepair,
      cityName,
      price,
      hasBillOfSale,
      hasMortgage
    });
  }, [
    leased,
    rooms,
    categoryId,
    hasRepair,
    cityName,
    price,
    hasBillOfSale,
    hasMortgage
  ]);

  useTargetedBanner(
    TargetedBannerIds.bg,
    adriverCustom,
    shouldNotRunOnRouter || false
  );
  useTargetedBanner(
    TargetedBannerIds.catfish,
    adriverCustom,
    shouldNotRunOnRouter || false
  );
};
